<!-- FIR EP Bump Confirmation Modal Component -->
<!-- Using shared confirmation modal component -->

<gtw-confirmation-modal
  [config]="modalConfig"
  [visible]="showModal"
  (confirmed)="onConfirm()"
  (cancelled)="onCancel()"
  (closed)="onCancel()">
</gtw-confirmation-modal>